<template>
  <v-container>
    <v-card class="pa-8 mx-auto" max-width="900">
      <!-- タイトル -->
      <v-row class="mb-6">
        <v-col class="text-center">
          <h2 class="text-h5 font-weight-bold mb-2">
            EDI申請詳細
          </h2>
        </v-col>
      </v-row>

      <!-- データの表示 -->
      <v-row v-if="!loading && formData" class="mb-4">
        <v-col cols="12">
          <edi-confirm-table :form-data="formData" />
        </v-col>
      </v-row>

      <!-- ローディング表示 -->
      <v-row v-if="loading">
        <v-col cols="12" class="text-center">
          <v-progress-circular
            indeterminate
            color="primary"
            size="64"
          />
        </v-col>
      </v-row>

      <v-divider class="my-6" />

      <!-- フッターボタン -->
      <v-row class="mt-8">
        <v-col :cols="canDelete ? 4 : 6">
          <v-btn
            block
            large
            outlined
            @click="goBack"
          >
            戻る
          </v-btn>
        </v-col>
        <v-col v-if="canDelete" cols="4">
          <v-btn
            block
            large
            color="error"
            outlined
            @click="handleDelete"
          >
            削除
          </v-btn>
        </v-col>
        <v-col :cols="canDelete ? 4 : 6">
          <v-btn
            block
            large
            color="primary"
            @click="goToEdit"
          >
            編集
          </v-btn>
        </v-col>
      </v-row>
    </v-card>
    <confirm ref="confirm" />
  </v-container>
</template>

<script>
import { mapActions } from 'vuex'
import EdiConfirmTable from '@/components/EdiConfirmTable'
import Confirm from '../../components/Confirm'

export default {
  name: 'EdiRequestSubscribedShow',
  components: {
    EdiConfirmTable,
    Confirm,
  },
  props: {
    ediRequestId: {
      type: [Number, String],
      required: true
    }
  },
  data() {
    return {
      loading: true,
      formData: null,
      ediStatus: null
    }
  },
  computed: {
    canDelete() {
      return this.ediStatus === 'emission_requested' || this.ediStatus === 'jwnet_requested'
    }
  },
  created() {
    this.fetchShowData()
  },
  methods: {
    ...mapActions('EdiRequestSubscribed', {
      fetchShow: 'show',
      destroySubscribed: 'destroy',
    }),
    fetchShowData() {
      this.loading = true
      const id = this.ediRequestId
      this.fetchShow({ id }).then(content => {
        // EDIステータスを保存
        this.ediStatus = content.edi_status
        // APIから取得したデータをformDataに設定
        this.formData = {
          id: content.id,
          jwnet_name: content.jwnet_name,
          corporation_code: content.corporation_code,
          corporate_designation_type: content.corporate_designation_type,
          emission_name: content.emission_name,
          emission_name_kana: content.emission_name_kana,
          zip_code: content.zip_code,
          prefecture_code: content.prefecture_code,
          address_1: content.address_1,
          address_2: content.address_2,
          address_3: content.address_3,
          contact_last_name: content.contact_last_name,
          contact_first_name: content.contact_first_name,
          contact_last_name_kana: content.contact_last_name_kana,
          contact_first_name_kana: content.contact_first_name_kana,
          contact_phone_number: content.contact_phone_number,
          email: content.email,
          phone_number: content.phone_number,
          jwnet_pricing_type: content.jwnet_pricing_type,
          subscriber_number: content.subscriber_number,
          edi_usage_key: content.edi_usage_key,
        }
        this.loading = false
      }).catch(error => {
        console.error('データの取得に失敗しました', error)
        this.loading = false
      })
    },
    goBack() {
      this.$router.push({ name: 'AdminEdiRequests' })
    },
    goToEdit() {
      this.$router.push({ 
        name: 'EdiRequestSubscribedEdit', 
        params: { id: this.ediRequestId } 
      })
    },
    handleDelete() {
      this.$refs.confirm.showDeleteConfirm().then((confirm) => {
        this.$refs.confirm.close()
        if (confirm) {
          const id = this.ediRequestId
          this.destroySubscribed({ id }).then(() => {
            this.$router.push({ name: 'AdminEdiRequests' })
          }).catch(error => {
            console.error('削除に失敗しました', error)
          })
        }
      })
    }
  }
}
</script>

<style scoped>
</style>
